"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.clearSavedState = clearSavedState;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _EpicPlansGotBetterBanner = require("./EpicPlansGotBetterBanner.scss");

var _EpicPlansGotBetterBanner2 = _interopRequireDefault(_EpicPlansGotBetterBanner);

var _selectors = require("../selectors");

var _TopBanner = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/TopBanner");

var _TopBanner2 = _interopRequireDefault(_TopBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setSavedState(dismissed) {
  localStorage.setItem("epicPlansGotSmarterBannerDismissed", dismissed);
}

function getSavedState(dismissed) {
  var value = localStorage.getItem("epicPlansGotSmarterBannerDismissed");
  return value === "true";
}

function clearSavedState() {
  localStorage.removeItem("epicPlansGotSmarterBannerDismissed");
}

var EpicPlansGotBetterBanner = function (_React$PureComponent) {
  (0, _inherits3.default)(EpicPlansGotBetterBanner, _React$PureComponent);

  function EpicPlansGotBetterBanner(props) {
    (0, _classCallCheck3.default)(this, EpicPlansGotBetterBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EpicPlansGotBetterBanner.__proto__ || (0, _getPrototypeOf2.default)(EpicPlansGotBetterBanner)).call(this, props));

    _this.handleBtnClick = _this.handleBtnClick.bind(_this);
    _this.handleDiscard = _this.handleDiscard.bind(_this);

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(EpicPlansGotBetterBanner, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.loggedIn && nextProps.loggedIn) {
        clearSavedState();

        this.setState({
          dismissed: getSavedState()
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        dismissed: getSavedState()
      });
    }
  }, {
    key: "handleDiscard",
    value: function handleDiscard() {
      setSavedState(true);

      this.setState({
        dismissed: true
      });
    }
  }, {
    key: "handleBtnClick",
    value: function handleBtnClick() {
      var router = this.props.router;


      this.handleDiscard();

      router.push({
        pathname: "/epic-migration",
        state: { modal: true, fromBanner: true }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isShowSwitchAndRefundBanner = this.props.isShowSwitchAndRefundBanner;
      var dismissed = this.state.dismissed;


      if (!__CLIENT__) {
        return null;
      }

      if (dismissed) {
        return null;
      }

      if (!isShowSwitchAndRefundBanner) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: _EpicPlansGotBetterBanner2.default.spaceWrap },
        _react2.default.createElement(_TopBanner2.default, {
          message: "Our plans just got better. Switch today and get a refund.",
          buttonText: "Learn How",
          onBtnClick: this.handleBtnClick,
          onDiscard: this.handleDiscard
        })
      );
    }
  }]);
  return EpicPlansGotBetterBanner;
}(_react2.default.PureComponent);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isShowSwitchAndRefundBanner: (0, _selectors.shouldShowSwitchAndRefundBanner)(state),
    loggedIn: state.auth.loggedIn
  };
})(EpicPlansGotBetterBanner);


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicPlansGotBetterBanner.jsx
// module id = 2612
// module chunks = 0